var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstaicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#FFB3A6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0957 9H10.9043C9.85439 9 9 9.85439 9 10.9043V20.0957C9 21.1459 9.85439 22 10.9043 22H20.0957C21.1459 22 22 21.1459 22 20.0957V10.9043C22 9.85439 21.1459 9 20.0957 9ZM21.2383 20.0957C21.2383 20.7256 20.7256 21.2383 20.0957 21.2383H10.9043C10.2744 21.2383 9.76172 20.7256 9.76172 20.0957V10.9043C9.76172 10.2744 10.2744 9.76172 10.9043 9.76172H20.0957C20.7256 9.76172 21.2383 10.2744 21.2383 10.9043V20.0957Z",
    fill: "#1B1A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6895 10.5488C19.2696 10.5488 18.9278 10.8906 18.9278 11.3105C18.9278 11.7305 19.2696 12.0723 19.6895 12.0723C20.1095 12.0723 20.4512 11.7305 20.4512 11.3105C20.4512 10.8906 20.1095 10.5488 19.6895 10.5488Z",
    fill: "#1B1A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 12.0723C13.61 12.0723 12.0723 13.6099 12.0723 15.5C12.0723 17.3901 13.61 18.9277 15.5001 18.9277C17.3901 18.9277 18.9278 17.3901 18.9278 15.5C18.9278 13.6099 17.3901 12.0723 15.5001 12.0723ZM15.5001 18.166C14.0299 18.166 12.834 16.9701 12.834 15.5C12.834 14.0299 14.0299 12.834 15.5001 12.834C16.9702 12.834 18.1661 14.0299 18.1661 15.5C18.1661 16.9701 16.9702 18.166 15.5001 18.166Z",
    fill: "#1B1A20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaicon);
export default __webpack_public_path__ + "static/media/instaicon.c7d875e118d4d97b5a08b1b555071a12.svg";
export { ForwardRef as ReactComponent };